// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6keKt","title":"styles_title__26-dK"};